import { render, staticRenderFns } from "./abandonDeviceManagement.vue?vue&type=template&id=5570e286&scoped=true"
import script from "./abandonDeviceManagement.vue?vue&type=script&lang=js"
export * from "./abandonDeviceManagement.vue?vue&type=script&lang=js"
import style0 from "./abandonDeviceManagement.vue?vue&type=style&index=0&id=5570e286&prod&scoped=true&lang=css"
import style1 from "./abandonDeviceManagement.vue?vue&type=style&index=1&id=5570e286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570e286",
  null
  
)

export default component.exports